/**
 * Colour theme (Suri, 2026-10-15): dark (the original) or light, chosen per phone with the button on the Home screen.
 * Dark is the default. The choice is stored in localStorage; index.html applies it before the page paints so there is no flash.
 */
const KEY = 'wr.theme';
export type Theme = 'dark' | 'light';

export function loadTheme(): Theme {
  try {
    return localStorage.getItem(KEY) === 'light' ? 'light' : 'dark';
  } catch {
    return 'dark';
  }
}

export function applyTheme(theme: Theme): void {
  document.documentElement.dataset.theme = theme;
  document.querySelector<HTMLMetaElement>('meta[name="theme-color"]')?.setAttribute('content', theme === 'light' ? '#1d4ed8' : '#0b1220');
}

export function toggleTheme(): Theme {
  const next: Theme = loadTheme() === 'light' ? 'dark' : 'light';
  try {
    localStorage.setItem(KEY, next);
  } catch {
    // Storage blocked: the theme then lasts until the page is reloaded.
  }
  applyTheme(next);
  return next;
}
